//请自行添加语言资源
const logDetail = {
  operation:'操作描述',
  platform:'操作平台',
  useTime:"耗时",
  ip:"ip",
  userNo:"用户",
  userName:"用户名称",
  createTime:"操作时间",
  msg:{

  }
};
export default logDetail



// WEBPACK FOOTER //
// ./src/page/int/logDetail/lang/logDetail.zh.js